export default __webpack_public_path__ + "static/media/discipline-arts.126f598f.svg";